<template>
  <md-button class="md-sm md-info md-reload" :disabled="disabled" @click="$emit('reload')">
    <md-icon>refresh</md-icon>
    {{ label }}
  </md-button>
</template>

<script>
export default {
  name: "DashboardReload",
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: "Refresh"
    }
  }
}
</script>

<style lang="scss" scoped>
.md-reload,
.md-reload:hover,
.md-reload:focus {
  background: #00000020 !important;
  color: #000 !important;
  border-radius: 100px;
  box-shadow: none;
  font-weight: 500 !important;
  text-transform: capitalize !important;

  i {
    color: #000 !important;
  }

  :deep(.md-button-content) {
    font-size: 11px !important;
  }

  :deep(.md-ripple) {
    padding: 4px !important;
  }
}
</style>
